module.exports = [
  {
    title: 'Installation',
    icon: 'fa-cloud-upload',
    single: true,
    location: '#/installation'
  },
  {
    title: 'My Account',
    icon: 'fa-user',
    single: true,
    location: '#/account'
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/config/menu.js